/**
 * Minimal i18next backend using fetch (replaces deprecated i18next-xhr-backend).
 */
class HttpBackend {
	static type = "backend"

	constructor(services, backendOptions = {}) {
		this.init(services, backendOptions)
	}

	init(services, backendOptions = {}) {
		this.services = services
		this.options = {
			loadPath: "/locales/{{lng}}/{{ns}}.json",
			...backendOptions
		}
	}

	read(language, namespace, callback) {
		const url = this.options.loadPath
			.replace("{{lng}}", language)
			.replace("{{ns}}", namespace)

		fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error(`Failed to load ${url}`)
				}
				return response.json()
			})
			.then((data) => callback(null, data))
			.catch((error) => callback(error, false))
	}
}

HttpBackend.type = "backend"

export default HttpBackend
